/**
 * Generates an error message when a value is undefined.
 * 
 * @param guardName - The name of the variable being guarded.
 * @returns A formatted error message.
 */
export const undefinedMessage = (guardName: string): string => `${guardName} is not defined`;

/**
 * Throws an error if the provided value is undefined.
 * 
 * @param guardName - The name of the variable being guarded.
 * @param guard - The value to check for undefined.
 * @throws {Error} Throws an error if `guard` is strictly equal to `undefined`.
 */
export const throwUndefined = (guardName: string, guard: any): void => {
  const isDefined = guard !== undefined;
  if (isDefined === false) {
    throw new Error(undefinedMessage(guardName));
  }
}